import IconButton from "@/components/atoms/IconButton";
import { ITableHeaderComponentProps } from "@/interfaces/Table";
import { faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ElementRef, FC, useRef } from "react";
import { Button, Col, FormControl, InputGroup, Row } from "react-bootstrap";
import StoreSoftphoneLineModal from "../modals/softphoneLine/StoreSoftphoneLineModal";

const AllSoftphoneLinesHeader: FC<ITableHeaderComponentProps> = ({
  onQueryChange,
}) => {
  const StoreModalRef =
    useRef<ElementRef<typeof StoreSoftphoneLineModal>>(null);

  return (
    <div className="d-lg-flex justify-content-between">
      <StoreSoftphoneLineModal ref={StoreModalRef} />
      <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto" className="pe-0">
          <h6 className="mb-0">Lignes softphone</h6>
        </Col>
        <Col xs="auto">
          <InputGroup className="position-relative input-search-width">
            <FormControl
              size="sm"
              id="search"
              type="search"
              className="shadow-none"
              placeholder="Rechercher"
              onChange={(e) => onQueryChange(e.target.value)}
            />
            <Button
              size="sm"
              variant="outline-secondary"
              className="border-300 hover-border-secondary"
            >
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <div className="border-bottom border-200 my-3"></div>
      <div className="d-flex align-items-center justify-content-end px-x1">
        <IconButton
          variant="nolina-default"
          size="sm"
          icon={faPlus}
          onClick={() => StoreModalRef.current?.showOrHiddenModal()}
          transform="shrink-3"
          iconAlign="middle"
        >
          <span className="d-none d-sm-inline-block ms-1">Nouveau</span>
        </IconButton>
      </div>
    </div>
  );
};

export default AllSoftphoneLinesHeader;
